import * as React from "react";
import { DialogContextInterface } from "./DialogInterface";

const DialogContext = React.createContext<DialogContextInterface>({
  dialogs: [],
  setDialog: () => {},
  closeDialogById: () => {},
  dialogRefs: () => {},
  addDialogRefById: () => {},
});

export default DialogContext;
